var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64.5,
    r: 64.5,
    fill: "#FDAB29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.4989 103.172C84.4474 103.172 100.619 95.0868 100.619 85.1125C100.619 75.1382 84.4474 67.0525 64.4989 67.0525C44.5504 67.0525 28.3789 75.1382 28.3789 85.1125C28.3789 95.0868 44.5504 103.172 64.4989 103.172Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4999 101.887C83.736 101.887 99.3299 94.3791 99.3299 85.1173C99.3299 75.8555 83.736 68.3473 64.4999 68.3473C45.2638 68.3473 29.6699 75.8555 29.6699 85.1173C29.6699 94.3791 45.2638 101.887 64.4999 101.887Z",
    fill: "white",
    stroke: "#FDAB29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4992 77.3793C78.7482 77.3793 90.2992 65.8283 90.2992 51.5793C90.2992 37.3304 78.7482 25.7793 64.4992 25.7793C50.2503 25.7793 38.6992 37.3304 38.6992 51.5793C38.6992 65.8283 50.2503 77.3793 64.4992 77.3793Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5002 76.0941C78.0367 76.0941 89.0102 65.1206 89.0102 51.5841C89.0102 38.0476 78.0367 27.0741 64.5002 27.0741C50.9637 27.0741 39.9902 38.0476 39.9902 51.5841C39.9902 65.1206 50.9637 76.0941 64.5002 76.0941Z",
    fill: "white",
    stroke: "#FDAB29"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.b6e7851a0e3994e20570853ad67c5078.svg";
export { ForwardRef as ReactComponent };